module.exports = __webpack_public_path__ + "img/1sb_logo_v3_white_v1.aab5efb.png";